export const REHYDRATE = 'persist/REHYDRATE';
export const flags = {
  DETAILS_POST: 'detailsPost',
  BOOK_POST: 'detailsPost',
  EMAIL_AVAILABILITY: 'emailAvailability',
  ACCOUNT_CREATION: 'accountCreation',
};

export const initialState = Object.keys(flags).reduce(
  (state, flag) => ({ ...state, [flags[flag]]: false }),
  { [REHYDRATE]: true },
);

const SET_LOADING_FLAG = 'loading/setLoadingFlag';

export const setLoadingFlag = (flag, isOn) => ({ type: SET_LOADING_FLAG, payload: { flag, isOn } });

export const loadingReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LOADING_FLAG:
      const { flag, isOn } = action.payload;
      return { ...state, [flag]: isOn };
    case REHYDRATE:
      return { ...state, [REHYDRATE]: false };
    default:
      return state;
  }
};
